import React from "react"

import { GlobalProvider } from "./src/context/Context"

export const wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element} </GlobalProvider>
}
